<template>
  <transition name="fade">
    <div class="menu-backdrop">
      <div
        class="menu"
        role="dialog"
        aria-labelledby="menuTitle"
        aria-describedby="menuDescription"
      >
        <header id="menu-header">
          <img src="@/assets/logo.png" alt="Se Prendió Logo" />
          <h1>SePrendió</h1>
        </header>
        <section id="menu-content">
          <div class="alert" v-show="alert" v-on:click="alert = false">
            {{ alert }}
          </div>
          <div class="setting who">
            <h2>¿ Con quién vas a jugar ?</h2>
            <button
              v-on:click="type = 1"
              v-bind:class="{ selected: type == 1 }"
            >
              Panas
            </button>
            <button
              v-on:click="type = 2"
              v-bind:class="{ selected: type == 2 }"
            >
              Culish
            </button>
          </div>
          <div class="setting">
            <h2>¿ Cuantos turnos ?</h2>
            <button
              v-on:click="roundsToPlay = 20"
              v-bind:class="{ selected: roundsToPlay == 20 }"
            >
              20
            </button>
            <button
              v-on:click="roundsToPlay = 30"
              v-bind:class="{ selected: roundsToPlay == 30 }"
            >
              30
            </button>
            <button
              v-on:click="roundsToPlay = 40"
              v-bind:class="{ selected: roundsToPlay == 40 }"
            >
              40
            </button>
            <button
              v-on:click="roundsToPlay = undefined"
              v-bind:class="{ selected: roundsToPlay == undefined }"
            >
              💀
            </button>
          </div>
          <div class="setting players">
            <h2>¿ Quienes van a jugar ?</h2>
            <div id="players-list" v-show="players.length > 0">
              <p v-for="(player, index) in players" :key="index">
                {{ player.name }}
              </p>
            </div>
            <button v-on:click="showModal = true" id="add-player-btn">
              Agregar jugadores
            </button>
            <modal v-if="showModal" v-on:close="showModal = false">
              <div class="players-settings" slot="content">
                <div class="player-info name">
                  <input type="text" placeholder="Nombre" v-model="name" />
                </div>
                <div class="player-info sex">
                  <p>Sexo</p>
                  <button
                    v-on:click="sex = 1"
                    v-bind:class="{ selected: sex == 1 }"
                  >
                    Hombre
                  </button>
                  <button
                    v-on:click="sex = 2"
                    v-bind:class="{ selected: sex == 2 }"
                  >
                    Mujer
                  </button>
                </div>
                <div class="player-info orientation">
                  <p>Orientación</p>
                  <button
                    v-on:click="orientation = 1"
                    v-bind:class="{ selected: orientation == 1 }"
                  >
                    Hetero
                  </button>
                  <button
                    v-on:click="orientation = 2"
                    v-bind:class="{ selected: orientation == 2 }"
                  >
                    Homo
                  </button>
                  <button
                    v-on:click="orientation = 3"
                    v-bind:class="{ selected: orientation == 3 }"
                  >
                    Bi
                  </button>
                </div>
                <button v-on:click="setPlayer" id="submit-players-btn">
                  Agregar jugador
                </button>
              </div>
            </modal>
          </div>
        </section>
        <footer id="menu-footer">
          <button type="button" v-on:click="setGame" aria-label="Set Game">
            Comenzar!
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import Modal from "./Modal.vue";

export default {
  name: "setterMenu",
  data() {
    return {
      players: [],
      showModal: false,
      name: "",
      sex: 0,
      orientation: 0,
      type: 1,
      roundsToPlay: 20,
      alert: false,
    };
  },
  components: {
    modal: Modal,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    setPlayer() {
      if (this.name.length < 1 || this.sex == 0 || this.orientation == 0) {
        this.alert = "Introduce todos los datos del jugador";
      } else {
        var newPlayer = {
          name: this.name,
          sex: this.sex,
          orientation: this.orientation,
        }; // sex : 1 - male , 2 - female ; orientation : 1 - hetero , 2 - homo , 3 - bi
        this.name = "";
        this.sex = 0;
        this.orientation = 0;
        this.players.push(newPlayer);
      }
    },
    setGame() {
      if (this.players.length >= 2) {
        if (this.type > 0) {
          var settings = {
            players: this.players,
            type: this.type,
            roundsToPlay: this.roundsToPlay,
          };
          this.$emit("setGame", settings);
          this.close();
        } else {
          this.alert = "Selecciona con quien vas a jugar";
        }
      } else {
        this.alert = "Necesitas agregar más jugadores";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../stylesheets/theme";
.menu-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // background-color: rgba(0, 0, 0, 0.3);
  background-color: color(pColor);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.menu {
  background-image: url("../assets/fire1.png"),
    linear-gradient(0deg, #0000, #0000, #ff0000c0);
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  padding: 5%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;

  @include medium {
    background-image: url("../assets/fire1.svg"),
      linear-gradient(0deg, #0000, #0000, #00000050);
    background-size: cover;
    padding: 2%;
  }

  #menu-header {
    display: flex;
    flex-direction: column;
    text-align: center;
    font-family: font(pFont);
    justify-content: center;
    color: color(dGray);
    line-height: initial;
    letter-spacing: 2px;

    h1 {
      font-size: 6vh;
      color: color(tColor);
      align-self: center;
    }

    img {
      height: 12vh;
      align-self: center;
    }
  }

  #menu-content {
    display: flex;
    flex-flow: column;
    justify-content: center;

    .alert {
      width: 100%;
      font-family: font(pFont);
      font-size: 2.5vh;
      padding: 1vh 0;
      background-color: color(danger);
      color: color(white);
      text-align: center;
      cursor: pointer;
    }

    .setting {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;

      &.players {
        flex-flow: column;

        #add-player-btn {
          width: max-content;
          padding: 0 30px;
          align-self: center;
        }
      }

      &.who {
        button {
          padding: 0 20px;
        }
      }

      h1,
      h2,
      p {
        color: color(white);
        font-family: font(tFont);
      }

      h2 {
        width: 100%;
        margin: 2vh 0;
      }

      .players-settings {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-self: center;

        @include small {
          flex-flow: row;
          flex-flow: wrap;
        }

        .player-info {
          display: flex;
          flex-flow: row;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 0.5vh;

          @include small {
            width: 100%;
            margin-bottom: 2vh;
          }

          input {
            padding: 1vh 3vw;
            border-radius: 100px;
            border: 1px solid color(lGray);
            font-size: 2.5vh;
            font-family: font(tFont);

            &:focus {
              outline: none;
            }
          }

          p {
            width: 100%;
            color: color(black);

            @include small {
              width: max-content;
            }
          }

          button {
            padding: 0 20px;
            color: color(white);
            background-color: color(pColor);

            @include medium {
              min-width: 6vw;
            }

            &.selected,
            &:hover {
              background-color: darken($color: color(questions), $amount: 10%);
              color: color(white);
            }

            &:focus {
              outline: none;
            }
          }
        }

        #submit-players-btn {
          background-color: color(games);
          color: white;
          margin-top: 1vh;
          padding: 0 10vw;
          align-self: center;

          &:hover {
            background-color: darken($color: color(games), $amount: 10%);
          }

          &:focus {
            outline: none;
          }
        }
      }
    }

    #players-list {
      display: flex;
      flex-direction: column-reverse;
      align-self: center;
      min-width: 200px;
      max-height: 150px;
      overflow-y: auto;
      width: max-content;
      padding: 0 10px;
      margin-bottom: 2.5vh;

      p {
        font-family: font(pFont);
        color: color(white);
        border-bottom: 1px solid color(lGray);
      }
    }

    button {
      font-family: font(tFont);
      font-size: 2.5vh;
      background-color: color(white);
      border: none;
      border-radius: 100px;
      color: color(black);
      margin: 0 1%;
      line-height: 200%;
      min-width: 13.5vw;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;

      @include medium {
        min-width: 6vw;
      }

      &.selected,
      &:hover {
        background-color: darken($color: color(questions), $amount: 10%);
        color: color(white);
      }

      &:focus {
        outline: none;
      }
    }
  }

  #menu-footer {
    display: flex;
    text-align: center;
    font-family: font(pFont);
    justify-content: center;
    padding-top: 3vh;

    button {
      font-family: font(tFont);
      color: color(white);
      border-radius: 100px;
      padding: 0 80px;
      margin: 1vh 0;
      font-size: 3vh;
      letter-spacing: 2px;
      background-color: color(games);
      border: none;
      font-weight: normal;
      cursor: pointer;

      &:hover {
        background-color: darken($color: color(games), $amount: 10%);
      }

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
